import { useCallback, useEffect, useState } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { fromJS } from 'immutable';

import { fetchLaoChatRecentContacts, sendLaoChatDM } from 'mastodon/actions/share';
import { Avatar } from 'mastodon/components/avatar';
import { useAppDispatch } from 'mastodon/store';

const messages = defineMessages({
  title: {
    id: 'share_modal.send_via_laochat',
    defaultMessage: 'Send via LaoChat',
  },
  empty: {
    id: 'share_modal.no_contacts',
    defaultMessage: 'No recent contacts',
  },
});

export const LaoChatZone = ({ statusUrl }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    fetchLaoChatRecentContacts()
      .then(data => {
        if (mounted) {
          setContacts(Array.isArray(data) ? data : []);
        }
      })
      .catch(() => {
        if (mounted) {
          setContacts([]);
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false);
        }
      });

    return () => {
      mounted = false;
    };
  }, []);

  const handleSend = useCallback(contactId => {
    dispatch(sendLaoChatDM(contactId, statusUrl));
  }, [dispatch, statusUrl]);

  return (
    <section className='share-modal__zone'>
      <h2 className='share-modal__zone-title'>{intl.formatMessage(messages.title)}</h2>
      <div className='share-modal__contact-list'>
        {!loading && contacts.length === 0 && (
          <div className='share-modal__empty'>{intl.formatMessage(messages.empty)}</div>
        )}

        {contacts.map(contact => (
          <button
            key={contact.id}
            type='button'
            className='share-modal__contact'
            onClick={() => handleSend(contact.id)}
          >
            <Avatar account={fromJS(contact)} size={44} />
            <span>{contact.display_name || contact.username || contact.acct}</span>
          </button>
        ))}
      </div>
    </section>
  );
};
